import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import './CheckoutPage.css';


const CheckoutSuccessPage = () => {
  const { paymentId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPaymentData();
  }, [paymentId]);

  const loadPaymentData = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/financial/rental-payments`);
      if (response.ok) {
        const data = await response.json();
        const paymentData = Array.isArray(data) 
          ? data.find(p => p.id === parseInt(paymentId)) 
          : null;
        if (paymentData) {
          setPayment(paymentData);
        }
      }
    } catch (err) {
      console.error('Error loading payment:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleContinue = () => {
    const returnPath = searchParams.get('return') || '/financial';
    navigate(returnPath);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount || 0);
  };

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        <div className="checkout-header">
          <div className="logo-section">
            <img 
              src="/favicon.ico" 
              alt="RentafAI Logo" 
              className="checkout-logo"
              onError={(e) => {
                e.target.style.display = 'none';
                if (e.target.nextSibling) {
                  e.target.nextSibling.style.display = 'block';
                }
              }}
            />
            <span className="logo-text" style={{ display: 'none' }}>RentafAI</span>
          </div>
        </div>

        <div className="success-state" style={{ padding: '60px 32px' }}>
          <div className="success-icon">✓</div>
          <h2>Payment Successful!</h2>
          <p>Your payment has been processed successfully.</p>

          {payment && (
            <div className="payment-summary" style={{ marginTop: '24px', maxWidth: '400px', width: '100%' }}>
              <div className="summary-row">
                <span className="summary-label">Payment ID:</span>
                <span className="summary-value">#{payment.id}</span>
              </div>
              <div className="summary-row">
                <span className="summary-label">Amount:</span>
                <span className="summary-value total-amount">{formatCurrency(payment.amount)}</span>
              </div>
              <div className="summary-row">
                <span className="summary-label">Status:</span>
                <span className="summary-value" style={{ color: '#10b981', fontWeight: 600 }}>
                  {payment.status === 'paid' ? 'Paid' : 'Processed'}
                </span>
              </div>
            </div>
          )}

          <div style={{ marginTop: '32px', display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button onClick={handleContinue} className="btn-primary">
              Continue
            </button>
            <button 
              onClick={() => window.print()} 
              className="btn-secondary"
            >
              Print Receipt
            </button>
          </div>

          <div className="security-notice" style={{ marginTop: '32px', maxWidth: '400px' }}>
            <span className="lock-icon">📧</span>
            <span>A receipt has been sent to your email address.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;

